import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import colors from '../../../assets/theme/colors';

const SectionButton = ({ active = false, children, onClick }) => (
  <Box
    component={active ? 'div' : ButtonBase}
    aria-current={active ? 'page' : undefined}
    onClick={active ? undefined : onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'flex-start',
      px: 1,
      py: 0.9,
      borderRadius: '10px',
      bgcolor: active ? colors.semantic.sageMist : 'transparent',
      color: active ? colors.semantic.sageActionInk : colors.semantic.ink,
      '&:hover': {
        bgcolor: active ? colors.semantic.sageSoft : colors.semantic.sageMist,
      },
    }}
  >
    <Typography sx={{ fontSize: '0.88rem', fontWeight: active ? 850 : 650, lineHeight: 1 }}>
      {children}
    </Typography>
  </Box>
);

export default SectionButton;
